import React from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import "./LoadingScreen.css";

function LoadingScreen({ showText }) {
  return (
    <div className="loadingScreen_container">
      <div className="loadingScreenInlineDiv">
        <AiOutlineLoading3Quarters className="loaderAnimation" />

        {showText && <p className="loadingScreenInlineDiv_text">Loading...</p>}
      </div>
    </div>
  );
}

export default LoadingScreen;
